import React from 'react'
import { I18n } from 'react-i18next'
import Dropzone from 'react-dropzone'
import request from 'superagent'
import './Uploader.css'

const onDrop = (files, url, callback) => {
  const req = request.post(url)
  req.attach('file', files[0])
  req.end((err, res) => {
    if (err) {
      console.error(err)
      throw err
    }
    callback(JSON.parse(res.text).data.src)
  })
}

const Uploader = ({ uploadHandler, onUpload, className }) => (
  <I18n>
    {(t, { i18n }) => (
      <Dropzone
        onDrop={files => onDrop(files, uploadHandler, onUpload)}
        style={{}}
        className={['configurator-uploader', className].join(' ')}
      >
        <span className='material-icons'>file_download</span>
        {t('configurator.createYourOwn')}
      </Dropzone>
    )}
  </I18n>
)

export default Uploader



// WEBPACK FOOTER //
// ./src/components/Uploader.js